__turbopack_context__.v({
  "action": "InscriptionSocialRow-module__lgOt1W__action",
  "actionRow": "InscriptionSocialRow-module__lgOt1W__actionRow",
  "alertText": "InscriptionSocialRow-module__lgOt1W__alertText",
  "alertsButton": "InscriptionSocialRow-module__lgOt1W__alertsButton",
  "alertsRow": "InscriptionSocialRow-module__lgOt1W__alertsRow",
  "belowImage": "InscriptionSocialRow-module__lgOt1W__belowImage",
  "btcAndPrice": "InscriptionSocialRow-module__lgOt1W__btcAndPrice",
  "btcLogo": "InscriptionSocialRow-module__lgOt1W__btcLogo",
  "buttonText": "InscriptionSocialRow-module__lgOt1W__buttonText",
  "calendarIcon": "InscriptionSocialRow-module__lgOt1W__calendarIcon",
  "collection": "InscriptionSocialRow-module__lgOt1W__collection",
  "collections": "InscriptionSocialRow-module__lgOt1W__collections",
  "content": "InscriptionSocialRow-module__lgOt1W__content",
  "contentContainer": "InscriptionSocialRow-module__lgOt1W__contentContainer",
  "details": "InscriptionSocialRow-module__lgOt1W__details",
  "emailInput": "InscriptionSocialRow-module__lgOt1W__emailInput",
  "emailInputText": "InscriptionSocialRow-module__lgOt1W__emailInputText",
  "footer": "InscriptionSocialRow-module__lgOt1W__footer",
  "footerMobile": "InscriptionSocialRow-module__lgOt1W__footerMobile",
  "footerRow": "InscriptionSocialRow-module__lgOt1W__footerRow",
  "header": "InscriptionSocialRow-module__lgOt1W__header",
  "headerLeft": "InscriptionSocialRow-module__lgOt1W__headerLeft",
  "headerTitle": "InscriptionSocialRow-module__lgOt1W__headerTitle",
  "icon": "InscriptionSocialRow-module__lgOt1W__icon",
  "imgContainer": "InscriptionSocialRow-module__lgOt1W__imgContainer",
  "leftButton": "InscriptionSocialRow-module__lgOt1W__leftButton",
  "mintAlertButton": "InscriptionSocialRow-module__lgOt1W__mintAlertButton",
  "mintAlertInput": "InscriptionSocialRow-module__lgOt1W__mintAlertInput",
  "mintImage": "InscriptionSocialRow-module__lgOt1W__mintImage",
  "options": "InscriptionSocialRow-module__lgOt1W__options",
  "rightButton": "InscriptionSocialRow-module__lgOt1W__rightButton",
  "root": "InscriptionSocialRow-module__lgOt1W__root",
  "socialPics": "InscriptionSocialRow-module__lgOt1W__socialPics",
  "socialRow": "InscriptionSocialRow-module__lgOt1W__socialRow",
  "socials": "InscriptionSocialRow-module__lgOt1W__socials",
  "subtitle": "InscriptionSocialRow-module__lgOt1W__subtitle",
  "textContent": "InscriptionSocialRow-module__lgOt1W__textContent",
  "title": "InscriptionSocialRow-module__lgOt1W__title",
  "twitterBlue": "InscriptionSocialRow-module__lgOt1W__twitterBlue",
  "twitterRow": "InscriptionSocialRow-module__lgOt1W__twitterRow",
  "twitterText": "InscriptionSocialRow-module__lgOt1W__twitterText",
  "waitlist": "InscriptionSocialRow-module__lgOt1W__waitlist",
});
